export default __webpack_public_path__ + "static/media/errorStateLogo.1300e9dc.svg";